export const CommonLocalizableString = `
  fragment CommonLocalizableString on LocalizableString {
    values(locales: $locales) {
      locale
      value
    }
  }
`;

export const CommonLocalizableImage = `
  fragment CommonLocalizableImage on LocalizableImage {
    values(locales: $locales) {
      locale
      value {
        originalImageUrl
      }
    }
  }
`;

export const CommonLocalizableVideo = `
  fragment CommonLocalizableVideo on LocalizableVideo {
    values(locales: $locales) {
      locale
      value {
        playbackUrl
        cfHlsUrl
        cfState
        cfVideoId
      }
    }
  }
`;

export const CommonLocalizableFile = `
  fragment CommonLocalizableFile on LocalizableFile {
    values(locales: $locales) {
      locale
      value {
        fileUrl
        filename
      }
    }
  }
`;

export const NonQuestionContentElement = `
  fragment NonQuestionContentElement on BoothContentElement {
    __typename
    ... on BoothRichtextContentElement {
      contentRichtextHtml {
        ...CommonLocalizableString
      }
    }
    ... on BoothImageContentElement {
      image {
        ...CommonLocalizableImage
      }
    }
    ... on BoothVideoContentElement  {
      videoFile {
        ...CommonLocalizableVideo
      }
    }
    ... on BoothFileContentElement {
      file {
        ...CommonLocalizableFile
      }
    }
  }
`;

export const CommonBoothTier = `
  fragment CommonBoothTier on BoothTier {
    __typename
    id
  }
`;

export const CommonBoothMetadata = `
  fragment CommonBoothMetadata on Booth {
    id
    appliedDesignCodename
    appointmentBookingUrl
    meetupEnabled
    website
    boothNumber
    rowOrder
    description {
      ...CommonLocalizableString
    }
    name {
      ...CommonLocalizableString
    }
    logo {
      ...CommonLocalizableImage
    }
    tier {
      ...CommonBoothTier
    }
    boothDesign {
      id
    }
    boothDesignCanvas {
      id
      previewImage {
        originalImageUrl
      }
    }
  }
`;

export const CommonBooth = `
  fragment CommonBooth on Booth {
    id
    appliedDesignCodename
    appointmentBookingUrl
    meetupEnabled
    website
    boothNumber
    rowOrder
    description {
      ...CommonLocalizableString
    }
    name {
      ...CommonLocalizableString
    }
    logo {
      ...CommonLocalizableImage
    }
    tier {
      ...CommonBoothTier
    }
    categories {
      nodes {
        id
        name {
          ...CommonLocalizableString
        }
      }
    }
    designElements {
      nodes {
        id
        name
        kind
        color
        image {
          ...CommonLocalizableImage
        }
        video {
          ...CommonLocalizableVideo
        }
        contentRichtextHtml {
          ...CommonLocalizableString
        }
        thumbnailImage {
          ...CommonLocalizableImage
        }
        pdf {
          ...CommonLocalizableFile
        }
      }
    }
    rootContentElement {
      tabs {
        nodes {
          title {
            ...CommonLocalizableString
          }
          body {
            nodes {
              __typename
              id
              ...NonQuestionContentElement
              ... on BoothQuestionContentElement {
                question {
                  ...CommonLocalizableString
                }
                answer {
                  ...NonQuestionContentElement
                }
              }
            }
          }
        }
      }
    }
  }
`;
